/**
 * Contract constants shared by the web app and the server.
 *
 * ARCHITECTURAL RULE: every HTTP route lives under a versioned prefix. When a
 * breaking API change is needed, add `/api/v2` and a parallel route tree rather
 * than mutating v1 in place.
 */
export const API_VERSION = 'v1';
export const API_V1_PREFIX = `/api/${API_VERSION}`;
/** Socket.IO endpoint path. Must match on both the server and the client. */
export const SOCKET_PATH = '/socket.io';
/**
 * Text ceilings.
 *
 * These are the HARD limits the schemas enforce and the columns can hold. The
 * limits actually applied are administrator settings (`SystemSettings`), which
 * may be set anywhere at or below these - see `domain/settings.ts`.
 */
/** `messages.content` is `text`; this bounds a single message regardless of settings. */
export const MESSAGE_CONTENT_MAX = 10_000;
/** `users.display_name` is `varchar(80)`. */
export const DISPLAY_NAME_MAX = 80;
/** `channels.name` is `varchar(120)`. */
export const CHANNEL_NAME_MAX = 120;
/** Upper bound on any password, so a hashing request cannot be made arbitrarily expensive. */
export const PASSWORD_MAX = 200;
/** A profile picture as a data URL. The browser resizes to 256px, which lands far below this. */
export const AVATAR_DATA_URL_MAX = 400_000;
/** Longest file name a shared file may carry. */
export const FILE_NAME_MAX = 255;
/**
 * File-sharing limits, shared because BOTH ends enforce them.
 *
 * The browser checks them so a doomed upload fails in the picker rather than
 * halfway through, and the server checks them because a client is not something
 * to trust.
 */
/**
 * 1 GiB: the most an upload may ever be. The size actually enforced is the
 * `maxFileTransferBytes` setting, which an administrator picks at or below this.
 * Shared files are held in server memory until downloaded or expired.
 */
export const TRANSFER_BYTES_CEILING = 1024 * 1024 * 1024;
/** The out-of-the-box limit: 100 MB. */
export const DEFAULT_MAX_TRANSFER_BYTES = 100 * 1024 * 1024;
//# sourceMappingURL=constants.js.map